<template>
  <v-form ref="create" @submit.prevent="store">
    <v-card>
      <v-card-title>Entri Jurnal Mengajar</v-card-title>
      <v-card-text>
        <v-alert
          v-show="is.submit"
          icon="mdi-clock-fast"
          color="blue"
          border="left"
          text
          >Menunggu.....</v-alert
        >
        <v-row>
          <v-col cols="12" lg="6">
            <v-autocomplete
              v-if="$root.app.isAdmin"
              @change="getJadwal"
              label="Guru"
              v-model="req.guru_id"
              :items="data.guru"
              :rules="[(v) => !!v || 'guru harus dipilih']"
            ></v-autocomplete>
            <v-text-field v-else :label="guruUser.nama" disabled></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-autocomplete
              @change="getJadwal"
              label="Mata Pelajaran"
              v-model="req.mata_pelajaran_id"
              :items="data.mata_pelajaran"
              :rules="[(v) => !!v || 'mata pelajaran harus dipilih']"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" lg="4">
            <v-autocomplete
              label="Rombel"
              v-model="req.rombel_id"
              :items="data.rombel"
              :rules="[(v) => !!v || 'rombel harus dipilih']"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" lg="4">
            <v-autocomplete
              label="Hari"
              v-model="req.hari"
              :items="data.hari"
              :rules="[(v) => !!v || 'hari harus dipilih']"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" lg="4">
            <v-text-field
              label="Ruang"
              placeholder="Masukkan Ruang"
              v-model="req.ruang"
              :items="data.ruang"
              :rules="[(v) => !!v || 'ruang harus dipilih']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-autocomplete
              label="Jam Awal KBM"
              v-model="req.jam_kbm_awal_id"
              :items="data.jam_kbm"
              :rules="[(v) => !!v || 'jam awal kbm harus dipilih']"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" lg="6">
            <v-autocomplete
              label="Jam Akhir KBM"
              v-model="req.jam_kbm_akhir_id"
              :items="data.jam_kbm"
              :rules="[(v) => !!v || 'jam akhir kbm harus dipilih']"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="Pokok Bahasan"
              v-model="req.pokok_bahasan"
              :rules="[(v) => !!v || 'pokok bahasan harus diisi']"
              rows="4"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-file-input
              @change="handleFile"
              counter
              show-size
              placeholder="Pilih Foto Dokumentasi"
              label="Foto Dokumentasi"
              ref="fotoUpload"
              :rules="[
                (v) => {
                  if (!!v) {
                    if (v.size > 2000000) {
                      return 'ukuran foto dokumentasi terlalu besar';
                    }
                  }
                  return true;
                },
              ]"
              accept="image/*"
            ></v-file-input>
            <span class="text-caption">Maksimal file foto 2 mb</span>
          </v-col>
          <v-col cols="12">
            <img
              :src="fotoUrl"
              :alt="fotoUrl"
              style="max-width: 100%; max-height: 300px"
              class="rounded"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn type="submit" color="primary" text
          ><v-icon>mdi-pen</v-icon> Simpan Entri</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      req: {},
      data: {
        tahun_ajaran: {
          tahun: new Date().getFullYear(),
          semester: "-",
        },
        mata_pelajaran: [],
        guru: [],
        jadwal: [],
        hari: [
          {
            value: "senin",
            text: "Senin",
          },
          {
            value: "selasa",
            text: "Selasa",
          },
          {
            value: "rabu",
            text: "Rabu",
          },
          {
            value: "kamis",
            text: "Kamis",
          },
          {
            value: "jumat",
            text: "Jumat",
          },
          {
            value: "sabtu",
            text: "Sabtu",
          },
        ],
        rombel: [],
        jam_kbm: [],
      },
      is: {
        submit: false,
      },
      fotoUrl: "",
    };
  },
  computed: {
    guruUser() {
      return this.data.guru[0]
        ? this.data.guru[0]
        : {
            nama: "",
          };
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.req.guru_id = parseInt(this.$root.app.xid);

      this.$root.app.http.get("/api/tahunajaran").then((res) => {
        res.data.forEach((item) => {
          if (item.status == "aktif") {
            this.req.tahun_ajaran_id = item.id;
            this.data.tahun_ajaran = item;
          }
        });
      });

      this.data.mata_pelajaran = [];
      this.$root.app.http.get("/api/matapelajaran").then((res) => {
        res.data.forEach((item) => {
          this.data.mata_pelajaran.push({
            value: item.id,
            text: item.nama,
          });
        });
      });

      this.data.guru = [];
      if (this.$root.app.isAdmin) {
        this.$root.app.http.get("/api/guru").then((res) => {
          res.data.forEach((item) => {
            this.data.guru.push({
              value: item.id,
              text: item.nama,
            });
          });
        });
      } else {
        this.$root.app.http
          .get("/api/guru/" + this.$root.app.xid)
          .then((res) => {
            this.data.guru.push(res.data);
          });
      }

      this.data.rombel = [];
      this.$root.app.http.get("/api/rombel").then((res) => {
        res.data.forEach((item) => {
          this.data.rombel.push({
            value: item.id,
            text: item.rombel,
          });
        });
      });

      this.data.jam_kbm = [];
      this.$root.app.http.get("/api/jamkbm").then((res) => {
        res.data.forEach((item) => {
          this.data.jam_kbm.push({
            value: item.id,
            text:
              "Ke-" +
              item.ke +
              " (" +
              item.mulai_pukul +
              " - " +
              item.akhir_pukul +
              ")",
          });
        });
      });
    },
    store() {
      if (this.$refs.create.validate()) {
        this.is.submit = true;
        this.req.status = "1";
        this.$root.app.http
          .post("/api/matapelajaran/jurnalmengajar", this.req)
          .then((res) => {
            this.is.submit = false;
            if (res.error) {
              this.$root.app.notif(res.message[0], true);
            } else {
              this.$root.app.notif(res.message);
              this.req = {};
              this.$router.push("/jurnal/list/" + res.data.id);
            }
          });
      }
    },
    handleFile(e) {
      if (!e) {
        this.fotoUrl = "";
        this.req.dokumentasi = "";
        return;
      }

      if (!!e) {
        if (e.size > 2000000) {
          // this.$refs.fotoUpload.value = null;
          this.req.dokumentasi = "";
          this.fotoUrl = "";
          return;
        }
      }
      this.$root.app.toBase64(e, (result) => {
        this.req.dokumentasi = result;
        this.fotoUrl = result;
        // this.$root.app.drive.upload(result).then((res) => {
        //   if (res.success) {
        //     this.req.dokumentasi = res.data;
        //     this.fotoUrl = res.data;
        //   } else {
        //     this.$root.app.notif(res.message, true);
        //   }
        // });
      });
    },
  },
};
</script>
